import { render, staticRenderFns } from "./weChatDetails.vue?vue&type=template&id=05defc04&scoped=true"
import script from "./weChatDetails.vue?vue&type=script&lang=js"
export * from "./weChatDetails.vue?vue&type=script&lang=js"
import style0 from "./weChatDetails.vue?vue&type=style&index=0&id=05defc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05defc04",
  null
  
)

export default component.exports